import { Action } from 'typescript-fsa';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '../store';
import { appActions } from '../actions/AppAction'
import { ItemComponent } from '../components/ItemComponent';

export interface AppActions {
    toggleSelected: (v: number) => Action<number>;
}

const mapDispatchToProps = (dispatch: Dispatch<Action<any>>) => {
    return  {
        toggleSelected: (id: number) => dispatch(appActions.toggleSelected(id))
    }
};

//const mapDispatchToProps = (dispatch: Dispatch<Action<any>>) => {dispatch};
const mapStateToProps = (state: AppState) => state;

export default connect(mapStateToProps, mapDispatchToProps)(ItemComponent);